// extracted by mini-css-extract-plugin
export var author = "Author-module--author--2kT-Q";
export var bio = "Author-module--bio--2YX8-";
export var twitter = "Author-module--twitter--1B6I5";